import React, { useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import AuthHeader from "../../../Helper/authHeader";
import * as Constants from "../../../Helper/constants/constants";
import EmailVerificationFunctions from "./function";
import OTPInput from "react-otp-input";
import ButtonLoader from "../../../Helper/buttonLoader";

const EmailVerification = () => {
    const {
        values,
        error,
        loader,
        handleChange,
        handleSubmit,
    } = EmailVerificationFunctions();

    return (
        <div className="forget_password_screen">
            <AuthHeader
                header={Constants.EMAIL_VERIFICATION}
                description={Constants.FOGET_PASSWORD_DESCRIPTION}
            />
            <Container>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div className="form">
                        <Form>
                            <div style={{ height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                <OTPInput
                                    value={values && values.otp}
                                    onChange={(e) => handleChange('otp', e)}
                                    numInputs={6}
                                    renderSeparator={<span>-</span>}
                                    renderInput={(props) => <input {...props} />}
                                    inputStyle={{ height: '100px', width: '100px' }}
                                    placeholder={''}
                                    // inputType={inputType}
                                    shouldAutoFocus
                                />
                                {error.otp.message ? (
                                    <p className="text-danger mt-2">
                                        {error.otp.message}
                                    </p>
                                ) : null}
                            </div>
                            <Button
                                type="submit"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSubmit();
                                }}
                                disabled={loader ? true : false}
                            >
                                {loader ? (
                                    <ButtonLoader
                                        loader={loader}
                                        variant={"light"}
                                        disabled={loader ? true : false}
                                    />
                                ) : null}
                                {loader ? "" : "Submit"}
                            </Button>
                        </Form>
                    </div>
                </Col>
            </Container>
        </div>
    );
};

export default EmailVerification;
